/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GroupDefinition } from './GroupDefinition';
import {
    GroupDefinitionFromJSON,
    GroupDefinitionFromJSONTyped,
    GroupDefinitionToJSON,
} from './GroupDefinition';

/**
 * 
 * @export
 * @interface GetGroups200Response
 */
export interface GetGroups200Response {
    /**
     * 
     * @type {Array<GroupDefinition>}
     * @memberof GetGroups200Response
     */
    records?: Array<GroupDefinition>;
}

/**
 * Check if a given object implements the GetGroups200Response interface.
 */
export function instanceOfGetGroups200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetGroups200ResponseFromJSON(json: any): GetGroups200Response {
    return GetGroups200ResponseFromJSONTyped(json, false);
}

export function GetGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroups200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(GroupDefinitionFromJSON)),
    };
}

export function GetGroups200ResponseToJSON(value?: GetGroups200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(GroupDefinitionToJSON)),
    };
}

